import { TileSet } from "~/lib/models/tile-set";
import { generateQueryString } from "~/lib/querystring";
import { getService } from "~/lib/services/services-manager";

export async function getClientGroups(clientUuid: string) {
  const service = getService("server-app");
  const result = await service.get(`/admin/groups/client/${clientUuid}`);
  return result.data.groups;
}

export async function getClientTileSets(clientUuid: string) {
  const service = getService("server-app");
  const queryParams = generateQueryString({ clientUuid });
  const result = await service.get(
    `/admin/geometries/tile-set/client${queryParams}`
  );
  return result.data.tileSets.map((ts) => TileSet.fromPayload(ts));
}

export async function getClientTileSetEntities(opts: any) {
  const service = getService("server-app");
  //pour l'instant, par défaut sur le back-office client on n'applique pas l'eventuelle restriction de territoire
  //pour éviter une auto restriction ou une restriction d'un compte client (celui de l'utilisateur connecté) sur le paramétrage d'un utilisateur d'un autre compte client
  if (typeof opts.bpterr === "undefined") opts.bpterr = true;
  const result = await service.get(
    `/geometries/tile-set/${opts.tsId}/entities${generateQueryString(opts)}`
  );
  return result.data.entities;
}

export async function replaceGroupState(groupUuid, type, resourcesUuids) {
  const service = getService("server-app");
  await service.post(`/admin/groups/resources/${groupUuid}/${type}`, {
    resourcesUuids,
  });
}

export const addResourcesToGroup = async (
  groupUuid: string,
  type: string,
  resourcesUuids: string[]
): Promise<void> => {
  const service = getService("server-app");
  await service.post(`/admin/groups/resources/${groupUuid}/${type}`, {
    resourcesUuids,
  });
};

export const removeResourcefromGroup = async (
  groupUuid,
  type,
  resourceUuid
) => {
  const service = getService("server-app");
  await service.delete(
    `/admin/groups/resources/${groupUuid}/${type}/${resourceUuid}`
  );
};

export async function getAllResourcesOfGroup(groupsUuids) {
  const service = getService("server-app");
  const result = await service.post(`/admin/groups/resources/`, {
    groupsUuids,
  });
  return result.data.resources;
}

export async function getMapOverlays(groupUuid) {
  const service = getService("server-app");
  const result = await service.post(`/admin/groups/resources/map-overlays`, {
    groupUuid,
  });
  return result.data.resources;
}

export async function getClientMaps(clientUuid, query = {}, getTotal = false) {
  const service = getService("server-app");
  const result = await service.get(`/admin/maps/client/${clientUuid}`, {
    params: query,
  });
  return getTotal ? result.data : result.data.maps;
}

export async function getNamespacedResourcesCompositionForClient(
  clientUuid,
  namespace
) {
  const service = getService("server-app");
  const result = await service.get(
    `/admin/clients/${clientUuid}/resources/${namespace}`
  );
  return result.data.resourcesCompositions;
}

export async function saveNamespacedResourcesCompositionForClient(
  clientUuid,
  namespace,
  data
) {
  const service = getService("server-app");
  const result = await service.post(
    `/admin/clients/${clientUuid}/resources/${namespace}`,
    data
  );
  return result.data.resourcesCompositions;
}

export async function getClientTags(clientUUID: string) {
  const service = getService("server-app");
  const result = await service.get(`/tags/client/${clientUUID}`);
  return result.data.tags;
}

export async function createClientTag(clientUUID: string, label: string) {
  const service = getService("server-app");
  const result = await service.post(`/tags`, { clientUUID, label });
  return result.data.tag;
}

export async function removeClientTags(clientUUID: string, tag) {
  console.log(clientUUID, tag);

  const service = getService("server-app");
  await service.delete(`/tags/client/${clientUUID}/${tag.id}`);
}
